<template>
  <section :class="`lead-table ${theme.isDark ? 'lead-table_dark' : null}`">
    <b-table
      :data="records"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="numberPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        field="createdAt"
        label="Date"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.createdAt }}
      </b-table-column>
      <b-table-column
        field="leadName"
        label="Lead Name"
        searchable
        sortable
        v-slot="props"
      >
        <router-link :to="'/lead/' + props.row.lead_id">
          {{ props.row.leadName }}
        </router-link>
      </b-table-column>
      <b-table-column
        field="agentName"
        label="Agent Name"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.agentName }}
      </b-table-column>
      <b-table-column field="url" label="Record" v-slot="props">
        <audio :key="props.row.id" ref="record" controls>
          <source :src="props.row.url" />
        </audio>
      </b-table-column>
    </b-table>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RecordsTable",
  inject: ["theme"],
  props: {
    records: Array,
  },
  data() {
    return {
      columns: [
        {
          field: "createdAt",
          label: "Date",
          searchable: true,
          sortable: true,
        },
        {
          field: "leadName",
          label: "Lead Name",
          searchable: true,
          sortable: true,
        },
        {
          field: "agentName",
          label: "Agent Name",
          searchable: true,
          sortable: true,
        },
        {
          field: "props.row.url",
          label: "Record",
          searchable: false,
          sortable: false,
        },
      ],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      perPage: 10,
    };
  },
  computed: {
    ...mapGetters({
      currentPage: "leads/currentPage",
    }),
    numberPage: {
      get: function () {
        return this.currentPage;
      },
      set: function () {
        this.SET_CURRENT_PAGE(1);
      },
    },
  },
};
</script>

<style scoped>
</style>